import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SelfAssessmentRoutingModule } from './self-assessment-routing.module';
import { SelfAssessmentLandingComponent } from './self-assessment-landing/self-assessment-landing.component';
import { SelfAssessmentLinkComponent } from './self-assessment-link/self-assessment-link.component';
import { SelfAssessmentComponent } from './self-assessment/self-assessment.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { AssessmentSubmitConfirmComponent } from './assessment-submit-confirm/assessment-submit-confirm.component';


@NgModule({
  declarations: [
    SelfAssessmentLandingComponent,
    SelfAssessmentLinkComponent,
    SelfAssessmentComponent,
    AssessmentSubmitConfirmComponent
  ],
  imports: [
    CommonModule,
    SelfAssessmentRoutingModule,
    AcademicFormModule,
    ReactiveFormsModule,
    FormsModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatCardModule,
    MatTableModule,
    MatDatepickerModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
  ]
})
export class SelfAssessmentModule { }
